import { gql } from '@apollo/client';

const CHECK_SIZE_REPORTS = gql`
  query checkSizeReports($studyId: ID!) {
    checkSizeReports(studyId: $studyId) {
      isSuccess
      message
    }
  }
`;

export default CHECK_SIZE_REPORTS;
